
    <router-outlet></router-outlet>
    <ng2-toasty [position]="'top-center'"></ng2-toasty>
    <kl-loading></kl-loading>
  